import React from "react";

interface DialogFieldProps {
  label?: string;
  children: React.ReactNode;
  className?: string;
}

export const DialogField: React.FC<DialogFieldProps> = ({
  label,
  children,
  className = "",
}) => {
  if (label) {
    return (
      <div className={className}>
        <label className="text-fg-medium mb-1 block">{label}</label>
        {children}
      </div>
    );
  }

  return <div className={className}>{children}</div>;
};
